// region Documentation
// Status Card Class
// The horizontal card that has no image and a potential status
// @param data = {}
//      data.title = link text for url
//      data.url = link for title portion of card
//      data.status = status used for styling.  ['published', 'draft']
// endregion
import statusCardTemplate from '../templates/statusCard.hbs';
import cardEllipsisTemplate from '../templates/cardEllipsis.hbs';
import $ from 'jquery';
$.fn.sdaStatusCard = function(data) {
    const that = this;
    const menuContent = $(that.find('.card-menu-content').html()).clone();
    const content = that.find('.card-info-content').html();

    // Status card has already been compiled do not recompile it
    if (that.is('[data-compiled]')) {
        return that;
    }

    data = data || {};

    $.extend(data, that.data());

    if (content) {
        data.htmlContent = content.trim();
    }

    that.html(statusCardTemplate(data));

    const $menu = that.find('.card-menu');

    if (menuContent && menuContent.length) {
        that.find('.card-menu-content')
            .html(menuContent)
            .append(cardEllipsisTemplate());

        that.find('.card-ellipsis').on('click', function() {
            $menu.toggleClass('card-menu-open');
        });
    }
    // Mark card as compiled
    that.attr('data-compiled', '');

    return that;
};
